import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HorusBtnDirective } from '@shared/directives/horus-btn.directive';
import { NotFoundSvgComponent } from './not-found-svg.component';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [HorusBtnDirective, NotFoundSvgComponent],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  private readonly router = inject(Router);

  goToPanel() {
    this.router.navigate(['/orders']);
  }
}
